import { axios } from '@/services/api/axiosInstance'
import { endpoints } from '@/services/api/endpoints'
import { clearUserInfo, updateUserInfo } from '@/store/features/userSlice'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import cookies from './cookies'

const ProtectedRoute = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const accessToken = cookies.get('ai_tk')

  const fetchUser = () => {
    axios
      .get(endpoints.getUserData.url)
      .then((res) => {
        if (!res.data?.data?.user_info.is_onboarded) {
          window.open(
            'https://play.aicade.io/onboarding?redirectTo=https://beta.aicade.io',
            '_self'
          )
        } else {
          dispatch(
            updateUserInfo({
              name: res.data?.data?.user_info.name,
              email: res.data?.data?.user_info.email,
              picture: res.data?.data?.user_info.profile_image,
              userId: res.data?.data?.user_info.user_id,
              lastLogin: res.data?.data?.user_info?.['last-login'],
              role: res.data?.data?.user_info.access_type,
              isOnboarded: res.data?.data?.user_info.is_onboarded,
            })
          )
        }
      })
      .catch(() => {
        dispatch(clearUserInfo())
        cookies.remove('ai_tk')
        navigate('/login', { replace: true })
      })
  }

  useEffect(() => {
    if (accessToken) {
      fetchUser()
    }
  }, [accessToken])

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return <Outlet />
}

export default ProtectedRoute
